export default __webpack_public_path__ + "static/media/finance-btn.050fb7cb.svg";